import uploadstestimonialspagebannerbgimagetestimonailsBannerJpg from "$lib/data/generated/uploads/testimonials/PageBanner/bgImage/Testimonails Banner.jpg";

export const uploads = {
  "uploads/testimonials/PageBanner/bgImage/Testimonails Banner.jpg": uploadstestimonialspagebannerbgimagetestimonailsBannerJpg
};